// extracted by mini-css-extract-plugin
export var text = "_au-0";